const challengesList = {
  "challenges.list.empty": "No challenges to display!",
};

const challengeModal = {
  "challenges.challenge.finished.modal.title.improved": "Congratulations!",
  "challenges.challenge.finished.modal.title.completed": "Congratulations!",
  "challenges.challenge.finished.modal.title.failed": "Better luck next time!",
  "challenges.challenge.finished.modal.body.improved": "You completed the challenge and earned a new reward.",
  "challenges.challenge.finished.modal.body.completed": "You completed the challenge and earned the {{ reward }}.",
  "challenges.challenge.finished.modal.body.failed": "You did not complete the challenge this time.",
  "challenges.challenge.finished.modal.targets.title": "Reach the following targets to earn a better reward:",
  "challenges.challenge.finished.modal.targets.your-score": "Your score:",
  "challenges.challenge.finished.modal.targets.next-target": "Target for next reward:",
};

const challengeSection = {
  "challenges.section.view": "View",
  "challenges.section.join.short": "Join",
  "challenges.section.join.full": "Join Challenge",
};

const challengeStatus = {
  'challenges.challenge.status.label': 'Status',
  'challenges.challenge.status.null': 'Not Started',
  'challenges.challenge.status.not_started': 'Not Started',
  'challenges.challenge.status.completed': 'Completed',
  'challenges.challenge.status.failed': 'Failed',
  'challenges.challenge.status.winner': 'Winner',
};

const challengesPage = {
  "challenges.page.title": "Challenges",
  "challenges.subheader.continue": "Continue",
  "challenges.subheader.categories": "Browse by Category",
  "challenges.subheader.drills": "Drill Challenges",
  "challenges.subheader.recently.played": "Recently Played",
  "challenges.promo.caption": "Challenge of the Month",
  "challenges.latest.caption": "Latest Challenge",
  "challenges.fallback.career.caption": "Continue Career to advance to new leagues and unlock Challenges!",
  "challenges.fallback.demo.title": "Trial",
  "challenges.fallback.demo.caption": "During your trial, you have access to a curated selection of challenges to help you get started.",
  "challenges.categories.all": "All",
  "challenges.list.active": "Active",
  "challenges.list.archived": "Archived",
};

const challengePage = {
  "challenges.challenge.page.title": "Challenge",
  "challenges.challenge.list.header": "Challenges ({{ challenges }})",
  "challenges.challenge.page.join": "Join",
  "challenges.challenge.page.details": "Details",
  "challenges.challenge.page.scenarios": " scenarios",
  "challenges.challenge.page.has-ended": "This challenge has ended",
  "challenges.challenge.page.ends-in": "Ends in {{ time }}",
  "challenges.challenge.page.not-started": "This Challenge has not started yet",
  "challenges.challenge.page.current.score": "Your current score",
  "challenges.challenge.page.current.score.main.metric": "BYB IQ:",
  "challenges.challenge.page.rewards": "Rewards",
  "challenges.challenge.page.leaderboard.title": "Leaderboard",
  "challenges.challenge.page.leaderboard.top": "Leaderboard (Top {{ count }})",
  "challenges.challenge.page.leaderboard.join": "Join",
  "challenges.challenge.page.leaderboard.see-all": "See all",
  "challenges.challenge.page.leaderboard.no-data": "No players have completed this challenge yet",
  "challenges.challenge.page.description": "Description",
  "challenges.challenge.page.results.title": "Your Results",
  "challenges.challenge.page.results.see-all": "See all results",
  "challenges.challenge.page.results.error.description": "Failed to load Challenge results",
};

const challengeCategoryPage = {
  "challenges.category.page.latest.challenge": "Latest Challenge",
  "challenges.category.page.grid.title": "{{ count }} Challenges",
};

const challengeReward = {
  "challenges.reward.target": "Target: {{ target }} {{ metric }}",
  "challenges.reward.place": "{{ place }} place",
  "challenges.reward.not.ranked": "Not ranked",
  "challenges.reward.achieved.on": "Earned on {{ date }}",
  "challenges.reward.not.achieved": "Not earned yet",
  "challenges.reward.scarcity": "Earned by {{ scarcity }}% of players who attempted this challenge",
  "challenges.reward.best.iq": "{{ iq }} BYB IQ",
};

const challengeCard = {
  "challenges.card.tooltip.locked.rating": "Advance in Career to unlock this Challenge",
  "challenges.card.tooltip.locked.demo": "Purchase a Be Your Best subscription to unlock this Challenge",
  "challenges.card.starts-in": "Starts in {{ time }}",
  "challenges.card.ends-in": "Ends in {{ time }}",
  "challenges.card.has-ended": "Ended",
  "challenges.play-challenge": "Play Challenge",
};

const challengeFilter = {
  "challenges.filter.title": "Filter",
  "challenges.filter.not_started": "Not Started",
  "challenges.filter.completed": "Completed",
  "challenges.filter.failed": "Failed",
  "challenges.filter.locked": "Locked",
  "challenges.filter.clear": "Clear all",
  "challenges.filter.apply": "Apply filters ({{ count }})",
};

const bootcamp = {
  "bootcamp.skip.confirmation.title": "Are you sure?",
  "bootcamp.skip.confirmation.description":
    "Skipping Bootcamp will take you directly to the main experience. You can still return to these Challenges later.",
  "bootcamp.skip.confirmation.cancel": "Keep training",
  "bootcamp.skip.confirmation.confirm": "Skip Bootcamp",
};

const challengeRewardScarcity = {
  "challenges.reward.scarcity.common": "Common",
  "challenges.reward.scarcity.uncommon": "Uncommon",
  "challenges.reward.scarcity.rare": "Rare",
  "challenges.reward.scarcity.epic": "Epic",
  "challenges.reward.scarcity.legendary": "Legendary",
};

export const challenges = {
  ...challengesList,
  ...challengeModal,
  ...challengeSection,
  ...challengesPage,
  ...challengePage,
  ...challengeStatus,
  ...challengeCategoryPage,
  ...challengeReward,
  ...challengeCard,
  ...challengeFilter,
  ...challengeRewardScarcity,
  ...bootcamp,
};
